export default __webpack_public_path__ + "static/media/a11y-en.15f89518.jpg";